<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    let {
        currentChoices = null,
        value = $bindable(),
        name = null,
        dependsOn,
        label,
        placeholder,
        defaultValue,
        disabled = false,
        inputProps = null,
        values = $bindable(),
        onInput,
    }: FieldComponentProps = $props()
    values = values || null

    if (!value) {
        if (defaultValue) value = defaultValue
        if (currentChoices && currentChoices[name] && value !== currentChoices[name]) {
            value = currentChoices[name]
        }
    }

    let input: HTMLInputElement = $state()
    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = $state(true)

    $effect(() => {
        if (dependsOn) {
            displayComponent = ruleEngine.resolve(dependsOn, values)
            if (!displayComponent) value = null
            else if (!value) value = defaultValue
        }
    })
    if (!inputProps) inputProps = {}
    if (inputProps) {
        for (const [key, value] of Object.entries(inputProps)) {
            if (key.startsWith("on") && typeof value === "string") {
                inputProps[key] = new Function("event", value)
            }
        }
    }
</script>

{#if displayComponent}
    <div class="number-input">
        {#if label}
            <label for="">{label}</label>
        {/if}
        <input
            bind:this={input}
            bind:value
            oninput={() => {
                if (onInput) onInput(value)
            }}
            type="number"
            {placeholder}
            {disabled}
            {...inputProps}
        />
    </div>
{/if}
